import type { EventInstance } from '../types';
import { getEventColor } from '../utils';

interface AllDayRowProps {
  dayColumns: { date: Date; events: EventInstance[] }[];
  onClickEvent: (event: EventInstance) => void;
  eventColorPriority?: 'event' | 'calendar';
}

export function AllDayRow({
  dayColumns,
  onClickEvent,
  eventColorPriority = 'event',
}: AllDayRowProps) {
  const hasEvents = dayColumns.some((col) => col.events.length > 0);
  if (!hasEvents) return null;

  return (
    <div className="border-b flex">
      {/* Hour label area */}
      <div className="w-14 shrink-0 text-[10px] text-muted-foreground text-right pr-2 py-1">
        all-day
      </div>

      {/* Day columns */}
      <div
        className="flex-1 grid"
        style={{ gridTemplateColumns: `repeat(${dayColumns.length}, 1fr)` }}
      >
        {dayColumns.map((col, i) => (
          <div key={i} className="border-r last:border-r-0 py-1 px-0.5 min-h-[28px]">
            {col.events.slice(0, 3).map((event) => (
              <button
                key={event.id}
                type="button"
                className="w-full text-[10px] truncate rounded px-1 py-0.5 mb-0.5 cursor-pointer hover:opacity-80 text-white text-left"
                style={{ backgroundColor: getEventColor(event, eventColorPriority) }}
                onClick={() => onClickEvent(event)}
              >
                {event.title}
              </button>
            ))}
            {col.events.length > 3 && (
              <div className="text-[10px] text-muted-foreground px-1">
                +{col.events.length - 3} more
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
